import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { PageHeader } from '../components/PageHeader';
import { Reveal } from '../components/Reveal';
import ContactStrip from '../components/ContactStrip';
import SEO from '../components/SEO';
import { getSeo, SEO_KEYWORDS } from '../data/seo';

const ExternalLinks = () => {
  const { t, lang } = useLang();
  const list = t('links.list');
  const seo = getSeo('links', lang);

  return (
    <div>
      <SEO title={seo.title} description={seo.description} path="/external-links" lang={lang} keywords={SEO_KEYWORDS[lang]} />
      <PageHeader label={t('links.label')} title={t('links.title')} lead={t('links.lead')} />
      <section className="bg-white py-16 lg:py-24">
        <div className="container-wide grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-5">
          {list.map((l, i) => (
            <Reveal key={i} delay={(i % 2) * 70}>
              <a
                href={l.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-start gap-4 p-6 rounded-xl bg-white border border-slate-200 hover:border-blue-300 hover:shadow-md hover:shadow-blue-700/5 transition"
              >
                <div className="inline-flex items-center justify-center w-11 h-11 rounded-lg bg-blue-700/5 border border-blue-700/15 text-blue-700 shrink-0">
                  <ExternalLink className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="text-[15px] font-bold text-slate-900 group-hover:text-blue-700 transition-colors">{l.label}</h3>
                  <p className="mt-1.5 text-[13.5px] text-slate-600 leading-relaxed">{l.desc}</p>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </section>
      <ContactStrip />
    </div>
  );
};

export default ExternalLinks;
